import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

const useStyles = makeStyles(theme => ({
  center: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm
  },

  mobileCenter: {
    margin: '1rem 0',

    [theme.breakpoints.down(bp)]: {
      alignItems: 'flex-start',
      flexDirection: 'row',
      margin: ' 0 0 0 0',
      gap: '1rem'
    }
  },

  iconBackground: {
    marginTop: '0.125rem',
    marginRight: '0.705rem',
    fontSize: theme.size.sm,
    cursor: 'pointer',
    backgroundColor: '#F1F1F1',
    padding: '0.25rem',
    borderRadius: '100%',

    [theme.breakpoints.down(bp)]: {
      padding: '0'
    }
  },

  attach: {
    opacity: 1,
    cursor: 'default',

    [theme.breakpoints.down(bp)]: {
      marginTop: '0.5rem'
    }
  },

  addVoice: {
    marginLeft: '2rem',
    cursor: 'pointer',
    '& label': {
      cursor: 'inherit'
    },
    [theme.breakpoints.down(bp)]: {
      marginTop: '0.5rem',
      marginLeft: 0
    }
  },

  audioText: {
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      gap: '0.75rem',
      justifyContent: 'baseline'
    }
  },

  file: {
    width: '95%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.5rem',
    padding: '0.5rem 0.25rem',
    border: '1px solid #F1F1F1',
    borderRadius: '5px',
    textOverflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0.5rem'
    }
  },

  text: {
    display: 'flex',
    width: '90%',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'default'
  },

  fileIcon: {
    fontSize: theme.size.sm,
    background: 'rgb(246, 247, 248)',
    padding: '2px',
    borderRadius: '2px',
    color: 'grey',
    height: 16,
    width: 16
  },

  clickable: {
    cursor: 'pointer',

    '& > *': {
      cursor: 'pointer !important'
    }
  },

  audio: {
    height: 21,
    marginLeft: 'auto'
  },
  recordingStatus: {
    display: 'flex',
    alignItems: 'center',
    animation: '$fading 2s infinite'
  },

  '@keyframes fading': {
    '0%': {
      opacity: 1
    },
    '50%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },

  recordingDot: {
    backgroundColor: 'red',
    borderRadius: '50%',
    height: 10,
    width: 9,
    marginRight: 5
  }
}))

export default useStyles
